import { render } from "./BookDetailCard.vue?vue&type=template&id=38906aff&scoped=true"
import script from "./BookDetailCard.vue?vue&type=script&lang=js"
export * from "./BookDetailCard.vue?vue&type=script&lang=js"

import "./BookDetailCard.vue?vue&type=style&index=0&id=38906aff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38906aff"]])

export default __exports__